import { Link } from 'react-router-dom';
import ButtonOne from "../../../components/buttons/buttonOne";

export default function IntroRoboticStudent() {
  return (
    <div className="relative flex h-full w-full flex-col items-center justify-center gap-y-[1rem] bg-[#4153C5] py-[10rem]">
        <div className="flex w-full flex-col items-center justify-center gap-y-[3rem] gap-x-[3rem] xl:w-[70%] xl:flex-row xl:items-start">
            <div className="my-[1rem] flex w-[80%] flex-col gap-y-[1rem] text-[20px] text-white xl:w-[40%]">
                <h2 id="kickstarter-kit" className="text-3xl font-bold">
                    A Robotics Kit for{" "}
                    <span className="text-[#F32047]">Students</span>
                </h2>

                <p>
                    Here at Takamori Robot we believe in teaching students real-world
                    engineering skills. Many competing kits, oversimplify engineering
                    skills, turning coding into drag and drop user experience, and
                    electronics into a game of plug and play that only works in their
                    kits ecosystem.
                </p>

                <p>
                    We build our robotics curriculums around microcontroller education.
                    We teach students the real-world electronics skills they need to
                    build and control a robotics kit like H.I.R.O. and even build their
                    own robots and devices outside the Takamori Robot ecosystem
                </p>
                <Link to="/education" className="mt-[2rem]" aria-label="Learn more about our beginner robotics course and engineering kit">
                    <ButtonOne 
                        bgColor="#F32047"
                    >
                        Education
                    </ButtonOne>
                </Link>
            </div>

            {/* Image with white fade background */}
            <div className="relative w-[80%] xl:w-[30%] mt-[2.5rem]">
                <div className="absolute inset-0 translate-x-[-1.5rem] translate-y-[-1.5rem] bg-gradient-to-b from-white/60 to-white/0" />
                <img
                    src="/pictures/introRoboticStudent.webp"
                    alt="Beginner-friendly engineering kit for education robotics and classroom use"
                    className="relative z-10 h-auto w-full"
                />
            </div>
        </div>
    </div>
  );
}